import { Component, inject, signal } from '@angular/core';
import { CartService } from '../../../services/cart.service';
import { CartItemComponent } from './cart-item/cart-item.component';
import { ButtonComponent } from '../../common/button/button.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';
import { RouterLink } from '@angular/router';
import { CheckoutService } from '../../../services/checkout.service';
import { forkJoin } from 'rxjs';
import { SharedNgxskeletonloaderModule } from '../../../services/ngxskeletonloader.module';

@Component({
    selector: 'app-cart',
    imports: [
        CartItemComponent,
        ButtonComponent,
        TranslatePipe,
        RouterLink,
        SharedNgxskeletonloaderModule,
    ],
    templateUrl: './cart.component.html',
})
export class CartComponent {
    cartService = inject(CartService);
    languageService = inject(LanguageService);
    checkoutService = inject(CheckoutService);
    translationService = inject(TranslateService);
    isRevalidating = signal(true);

    constructor() {
        this.revalidateCart();
    }

    revalidateCart() {
        this.translationService
            .get('product.notAvailableAnymore')
            .subscribe((translation) => {
                const observable = this.cartService
                    .cartItems()
                    .map((item) =>
                        this.checkoutService.revalidateCartItem(
                            item,
                            translation,
                        ),
                    );

                forkJoin(observable).subscribe(() => {
                    this.isRevalidating.set(false);
                });
            });
    }
}
